import React from 'react';
import PropTypes from 'prop-types';
import Close from '../../shared/components/Close';

import classes from './index.module.scss';

const Header = ({ children, onClose }) => (
    <header className={classes.modalContentSlimHeader}>
        {children && <h4 className={classes.title}>{children}</h4>}
        <Close onClick={onClose}/>
    </header>
);

Header.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func
};

Header.defaultProps = {
    onClose: () => null
};

export default Header;
